export const getUnseenTaskIds = (taskIds, shownIds) =>
	taskIds.filter(id => !shownIds.includes(id))

export const getLatestFinishedAt = tasks =>
	tasks.reduce((latest, task) => (task.finishedAt > latest ? task.finishedAt : latest), '')
